// extracted by mini-css-extract-plugin
module.exports = {"comparison":"ComparisonSection_comparison__2CY78","productImage":"ComparisonSection_productImage__stuAr"};